import React, { useEffect, useRef, useState } from "react";
import { Button, Text } from "components";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";

import DeliveryChallanInwardTransactionList from "./DeliveryChallanInwardTransactionList";
import Tabs from "components/TabNavBar/Tab";
import Breadcrumb from "components/Breadcrumb/Breadcrumb";

const tabItems = [
  {
    label: "Transaction",
    value: "PurchaseHistory",
  },
];

const DeliveyChallanInwardAll = () => {
  const [download, setDownload] = useState(false);
  const navigate = useNavigate();
  const childRef = React.useRef(null);
  const [activeTab, setActiveTab] = useState();

  const location = useLocation();
  const code = location.state?.code;

  const [erplist, setErplist] = useState([]);

  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  useEffect(() => {
    setActiveTab(
      sessionStorage.getItem("tab") == "PurchaseHistory"
        ? "PurchaseHistory"
        : sessionStorage.getItem("tab")
    );
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    sessionStorage.setItem("tab", tab);
  };

  const addHandler = () => {
    if (activeTab === "PurchaseHistory") {
      navigate(`/stocktransaction/purchase/add`, { state: { code: code } });
    }
  };

  function downloadExcel() {
    childRef.current.downloadExcel();
  }
  function downloadPdf() {
    childRef.current.downloadPdf();
  }

  return (
    <>
      {erplist.some((item) => item.erp_module_id == 20 && item.view) ? (
        <div className="w-full flex flex-col">
          <div className="flex flex-row w-full items-end mt-3">
            {/* <div>
              {activeTab === "PurchaseHistory" && (
                <Link
                  to="/stocktransaction/purchaselist"
                  onClick={() => sessionStorage.setItem("tab", "Purchase")}
                >
                  <Text
                    className="text-2xl md:text-[22px] whitespace-nowrap text-gray-800 sm:text-xl tracking-[0.20px] w-[85px]"
                    size="txtInterSemiBold24"
                  >
                    <div className="flex flex-row">
                      <div
                        className="hover:cursor-pointer whitespace-nowrap underline text-base"
                        onClick={() =>
                          navigate("/stocktransaction/purchaselist")
                        }
                      >
                        Stock Transaction
                      </div>
                      <div className="whitespace-nowrap px-1 text-base">/</div>
                      <div className="whitespace-nowrap px-1 text-base">
                        Delivery Challan Inward
                      </div>
                      <div className="whitespace-nowrap px-1 text-base">/</div>
                      <div className="whitespace-nowrap text-base">{code}</div>
                    </div>
                  </Text>
                </Link>
              )}
            </div> */}
            <Breadcrumb
              items={[
                {
                  label: "Stock Transaction",
                  path: "/stocktransaction/purchaselist",
                },
                {
                  label: "Delivery Challan Inward",
                },
                {
                  label: code,
                },
              ]}
            />

            <div className="flex text-3xl gap-2 flex-row justify-end items-center font-inter px-[10px] w-full leading-none  tracking-tight text-gray-900 md:text-4xl lg:text-5xl dark:text-white ">
              <div
                className="flex flex-col relative z-20"
                onMouseEnter={() => setDownload(!download)}
                onMouseLeave={() => setDownload(!download)}
              >
                <button
                  id="dropdownDefaultButton"
                  data-dropdown-toggle="dropdown"
                  className="text-white-A700 bg-blue-700 ${do} hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  type="button"
                >
                  {"Download"} &nbsp;{" "}
                  <svg
                    class="w-2.5 h-2.5 ms-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 4 4 4-4"
                    />
                  </svg>
                </button>
                <div
                  className={`${
                    download ? "absolute top-[32px]" : "hidden"
                  } z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-[110px] bg-white-A700  dark:bg-gray-700`}
                >
                  <ul
                    class="py-0 text-sm text-gray-700 dark:text-gray-200"
                    aria-labelledby="dropdownDefaultButton"
                  >
                    <li>
                      <a
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        onClick={downloadPdf}
                      >
                        PDF
                      </a>
                    </li>
                    <li>
                      <a
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        onClick={downloadExcel}
                      >
                        Excel
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* <div className='w-full pt-2'>
          <nav className=" p-1 bg-slate-100">
            <div className="container mx-auto">
              <ul className="flex">
                <li className={`mr-6 ml-6 p-2 w-30 text-sm ${activeTab === 'PurchaseHistory' ? 'bg-gray-150 text-blue-500 shadow-md' : ''}`}>
                  <Button className="text-white" onClick={() => { handleTabClick('PurchaseHistory'); }}>Transaction</Button>
                </li>
               
              </ul>
            </div>
          </nav>
        </div> */}
          <Tabs
            tabs={tabItems}
            activeTab={activeTab}
            onTabChange={handleTabClick}
          />
          <div>
            {activeTab === "PurchaseHistory" && (
              <DeliveryChallanInwardTransactionList ref={childRef} />
            )}
          </div>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
};

export default DeliveyChallanInwardAll;
